function ProfileLinks({ variant = "default" }) {
  return (
    <div className={`profile-links-container ${variant}`}>
      
      {/* Email button */}
      <button
        type="button"
        className="icon-with-tooltip"
        aria-label="Send me an email (opens in a new tab)"
        onClick={() => {
          const email = "vvanmaa.dev@gmail.com";
          const url = `https://mail.google.com/mail/?view=cm&to=${email}`;
          window.open(url, "_blank", "noopener,noreferrer");
        }}
      >
        <i className="bi bi-envelope" aria-hidden="true"></i>
        <span className="tooltip-text">Message me</span>
      </button>

      {/* GitHub */}
      <div className="icon-with-tooltip">
        <a
          href="https://github.com/Van-Ma"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Visit my GitHub profile (opens in a new tab)"
        >
          <i className="bi bi-github" aria-hidden="true"></i>
        </a>
        <span className="tooltip-text">GitHub</span>
      </div>

      {/* LinkedIn */}
      <div className="icon-with-tooltip">
        <a
          href="https://www.linkedin.com/in/van-ma-a3944a29a"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Visit my LinkedIn profile (opens in a new tab)"
        >
          <i className="bi bi-linkedin" aria-hidden="true"></i>
        </a>
        <span className="tooltip-text">LinkedIn</span>
      </div>

      {/* Resume */}
      <div className="icon-with-tooltip resume-icon">
        <a
          href="/pdfs/resume2.pdf"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Open my resume PDF (opens in a new tab)"
        >
          <i className="bi bi-file-person-fill" aria-hidden="true"></i>
        </a>
        <span className="tooltip-text">My resume</span>
      </div>

    </div>
  );
}

export default ProfileLinks;
